module.exports = __webpack_public_path__ + "img/btnStatus11.3c2b853f.png";